import { render } from "./FailToConfirm.vue?vue&type=template&id=6c190337&ts=true"
import script from "./FailToConfirm.vue?vue&type=script&lang=ts"
export * from "./FailToConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__